import Script from "next/script";
import { components } from "@zapier/api-clients/apis/templates-backend";

export type TemplateFAQ = components["schemas"]["Faq"];

interface FAQSchemaProps {
  questions: TemplateFAQ[] | null;
}

export const FAQSchema = ({ questions }: FAQSchemaProps) => {
  if (!questions) return null;

  const FAQJson = {
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: questions.map((question) => ({
        "@type": "Question",
        name: question.name,
        acceptedAnswer: {
          "@type": "Answer",
          text: question.content,
        },
      })),
    }),
  };

  return (
    <Script
      type="application/ld+json"
      dangerouslySetInnerHTML={FAQJson}
      key="template-faq-jsonld"
    />
  );
};
